import React from 'react';
import { LiliDropdownItem } from './LiliDropdown';
import { ReactComponent as CheckMark } from '../../assets/icons/svg/shared/ic-shared-checkmark.svg';

interface LiliDropdownItemProps {
  item: LiliDropdownItem;
  isSelected: boolean;
}

export const LiliDropDownItemTemplate = ({
  item,
  isSelected,
}: LiliDropdownItemProps) => (
  <div
    className='px-[8px] py-[4px] !h-[44px]  items-center border-t-[1px] border-t-bw03 w-full '
    key={item.value}
  >
    <div
      className={`flex flex-row  justify-between w-full hover:bg-bw02 rounded-md px-[12px] py-[6px] ${isSelected ? 'bg-action00' : ''} `}
    >
      <div
        className={`font-metricR text-[14px]  ${isSelected ? 'text-action03' : 'text-bw08'}`}
      >
        {item.title}
      </div>
      {isSelected && <CheckMark className='text-action03' />}
    </div>
  </div>
);
